<div class="base-knowledge">
    <div class="category-container" *ngFor="let category of filteredCategoryListLearned">
        <div class="category-container__header" (click)="toggleCategory(category)">
            <div class="category-container__header-title">
                <bzg-icon [nameIcon]="category.Expanded ? 'icon-arrow-down-black' : 'icon-arrow-right-black'" [size]="14"></bzg-icon>
                <span>{{ category.DisplayName }}</span>
            </div>
        </div>
        <div *ngIf="category.Expanded">
            <div >
                <table *ngIf="category.KBLearned.length > 0" class="category-container__table">
                    <thead>
                        <tr>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.BIZAGI_DATA' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.FREQUENCY' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.START_DATE' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.STATUS' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let kbLearned of getSortedKBLearned(category)">
                            <td title="{{ kbLearned.DisplayName }}" class="category-container__table-entity">
                                <!-- <bzg-icon [nameIcon]="'icon-knowledge-entity'" class="icon-ai-tools" [size]="14"></bzg-icon> -->
                                <span>{{ kbLearned.DisplayName }}</span>
                            </td>
                            <td title="{{ kbLearned.Frequency }}" class="category-container__table-attributes">
                                <span>{{ kbLearned.Frequency }}</span>
                            </td>
                            <td title="{{ kbLearned.StartDate | date: 'shortDate' }}" class="category-container__table-segments">
                                <span>{{ kbLearned.StartDate | userTimezoneFormat:1 }}</span>
                            </td>
                            <td class="category-container__table-status">
                                <div class="status" title="{{ kbLearned.StatusLocalized }}">
                                    <span class="status-dot" [ngClass]="{
                                        'completed': kbLearned.Status === Completed,
                                        'in-progress': kbLearned.Status === InProgress,
                                        'failed': kbLearned.Status === Failed,
                                        'not-executed': kbLearned.Status === NotExecuted,
                                        'delivered': kbLearned.Status === Delivered,
                                        'awaiting': kbLearned.Status === Awaiting,
                                        'not-found': kbLearned.Status === NotFound,
                                        'error-searching': kbLearned.Status === ErrorSearching
                                    }">
                                    </span>
                                    {{ kbLearned.StatusLocalized }}
                                </div>
                                <div  title="{{ 'BASEKNOWLEDGECATALOG.RETRY' | translate }}" *ngIf="kbLearned.Status === Failed">
                                    <bzg-icon [nameIcon]="'icon-ai-reset'" class="icon-refresh" [size]="14"  (click)="refreshKBLearned(kbLearned)"></bzg-icon>
                                </div>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="category.KBLearned.length === 0"
                    class="category-container__no-artifacts">{{ 'BASEKNOWLEDGECATALOG.NO_ARTIFACTS' | translate }}</div>
            </div>
        </div>
    </div>
    <div *ngIf="filteredCategoryListLearned.length === 0" class="category-container__no-elements">
        <img src="assets/img/no_found.png">
        <span>{{ 'BASEKNOWLEDGECATALOG.NO_ELEMENTS' | translate }}</span>
    </div>
</div>

